<div class="container">
    <div class="row">
        <div class="col-sm-12">
            <h1 class="main-heading">{{ 'rpe.vista-registro-actividad.title' | translate }}</h1>
        </div>
    </div>    
    <div class="row">
        <rpe-entity-registro-actividad-form-container></rpe-entity-registro-actividad-form-container>
    </div>
</div>
  